import { render, staticRenderFns } from "./DropdownLanguage.vue?vue&type=template&id=bada7d8c&scoped=true"
import script from "./DropdownLanguage.vue?vue&type=script&lang=js"
export * from "./DropdownLanguage.vue?vue&type=script&lang=js"
import style0 from "./DropdownLanguage.vue?vue&type=style&index=0&id=bada7d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bada7d8c",
  null
  
)

export default component.exports